define('util/domUtils',[
    'jquery',
    'lib/lodash4'
], function (
    $,
    _
) {
    'use strict';

    var utils = {
        /**
         * Get the width of a scrollbar in the browser.
         *
         * @return {Integer} The width of a scrollbar in the browser.
         */
        getScrollbarWidth: _.once(function () {
            // Create the measurement node
            var scrollDiv = $("<div/>")
                .css({
                    "width": "100px",
                    "height": "100px",
                    "overflow": "scroll",
                    "position": "absolute",
                    "top": "-9999px"
                })
                .appendTo(document.body)[0];

            // Get the scrollbar width
            var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

            // Delete the DIV
            $(scrollDiv).remove();

            return scrollbarWidth;
        }),

        /**
         * Get the size of a hidden element
         *
         * @param {Object} obj The element of which to get the size
         * @return {Object} The (outer) width and height of the element
         */
        getHiddenElementOuterSize: function (obj) {
            if ($(obj).length === 0) {
                return undefined;
            }
            var clone = obj.clone();
            clone.css({
                visibility: 'hidden',
                width: '',
                height: '',
                maxWidth: '',
                maxHeight: ''
            });
            $('body').append(clone);
            var width = clone.outerWidth();
            var height = clone.outerHeight();
            clone.remove();
            return {width: width, height: height};
        }
    
    };

    return utils;
});

